// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3nuB6","approved":"Status_approved__js_Ic","rejected":"Status_rejected__18L2w","expired":"Status_expired__3jlQv","label":"Status_label__WjxM0"};